<template>
    <svg
        height="24px"
        width="24px"
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 236.816 236.816"
        style="enable-background: new 0 0 236.816 236.816; fill: currentColor"
        xml:space="preserve"
    >
        <g>
            <path
                d="M203.424,47.001L165.372,9.224C160.076,3.966,150.455,0,142.991,0H41.581
                c-9.649,0-17.5,7.851-17.5,17.5v201.816c0,9.649,7.851,17.5,17.5,17.5h153.655c9.649,0,17.5-7.851,17.5-17.5V69.369
                C212.736,61.888,208.732,52.271,203.424,47.001z M191.479,56.278h-30.425c-1.355,0-2.5-1.145-2.5-2.5V23.591L191.479,56.278z
                M195.236,221.816H41.581c-1.355,0-2.5-1.145-2.5-2.5V17.5c0-1.355,1.145-2.5,2.5-2.5h101.411c0.181,0,0.371,0.011,0.562,0.023
                v38.756c0,9.649,7.851,17.5,17.5,17.5h36.683v148.038C197.736,220.672,196.591,221.816,195.236,221.816z"
            />
            <path
                d="M64.061,71.278h50c4.142,0,7.5-3.357,7.5-7.5c0-4.143-3.358-7.5-7.5-7.5h-50
                c-4.142,0-7.5,3.357-7.5,7.5C56.561,67.921,59.919,71.278,64.061,71.278z"
            />
            <path
                d="M173.392,182.115h-50c-4.142,0-7.5,3.357-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h50
                c4.142,0,7.5-3.357,7.5-7.5C180.892,185.473,177.534,182.115,173.392,182.115z"
            />
            <path
                d="M173.392,91.553H64.061c-4.142,0-7.5,3.357-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h109.331
                c4.142,0,7.5-3.357,7.5-7.5C180.892,94.91,177.534,91.553,173.392,91.553z"
            />
            <path
                d="M173.392,126.827H64.061c-4.142,0-7.5,3.357-7.5,7.5c0,4.143,3.358,7.5,7.5,7.5h109.331
                c4.142,0,7.5-3.357,7.5-7.5C180.892,130.185,177.534,126.827,173.392,126.827z"
            />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
    name: "oss-letter",
});
</script>
